export enum GroupStyle {
    OneColumn,
    TwoColumn,
    HorizontalScroll,
    Wrap,
}
